<div class="NavigationLink_container" [ngStyle]="customStyle">
  <span class="NavigationLink_linkText BasisGrotesqueProBold FontSize_Rem_0_688 LineHeight_Rem_0_75 CP_pointer"
    (click)="onNavigate()">
    @switch (routeType) {
      @case (CompogeniusNaviTypeEnum.CLASS) {
        @if (!isSuperClass) {
          {{ (!!customText ? customText : 'DESIGN_B.NAVIGATION.TO_CLASS') | translate }}
        }
        @if (isSuperClass) {
          {{ (!!customText ? customText : 'DESIGN_B.NAVIGATION.TO_SUPERCLASS') | translate }}
        }
      }
      @case (CompogeniusNaviTypeEnum.OBJECT) {
        {{ (!!customText ? customText : 'DESIGN_B.NAVIGATION.TO_OBJECT') | translate }}
      }
      @case (CompogeniusNaviTypeEnum.JOB_FILL_OUT_OBJECT) {
        {{ (!!customText ? customText : 'DESIGN_B.NAVIGATION.TO_OBJECT') | translate }}
      }
      @case (CompogeniusNaviTypeEnum.COLLECTION_OBJECT) {
        {{ (!!customText ? customText : 'DESIGN_B.NAVIGATION.TO_OBJECT') | translate }}
      }
      @default {
        {{ customText  | translate }}
      }
    }
  </span>
</div>

